import React, { Component } from 'react';
import ContentHeader, { ContentHeaderProps } from '@common/component/organisms/ContentHeader';
import NegotiationCountListContainer from '@common/container/organisms/NegotiationCountListContainer';
import CustomCountListContainer from '@common/container/organisms/CustomCountListContainer';
import { StoreAndAgencyInfo, StoreSelectorState } from '@common/redux/reducers/StoreSelectorReducer';
import { LoadingStatusReducerState } from '@common/redux/reducers/LoadingStatusReducer';
import { UserState } from '@common/redux/reducers/UserReducer';
import Layout from '../Layout';
import SearchConditionInput from '@common/container/molecules/SearchConditionInputContainer';
import { Badge } from '@common/component/atoms/Badge';
import { Collapse, Icon } from '@material-ui/core';
import classNames from 'classnames';
import StoreSelectModal from '../../../container/organisms/StoreSelectModalContainer';
import Drawer from '@common/component/atoms/Drawer';
import IconButton from '@common/component/atoms/IconButton';
import Button from '@common/component/atoms/Button';
import { getAgencyStoreShortName } from '@common/component/organisms/FilterSettingDrawer/function';
import {
  LASTEST_SUMMARY_SPOT_EVENT_MAPPING,
  DASHBOARD_CUSTOM_COUNT_SPOT_EVENT_MAPPING,
  REFRESH_SPOT_EVENT_MAPPING,
  DASHBOARD_HEADER_SPOT_EVENT_MAPPING,
} from '@common/Common';

interface LatestSummaryProps {
  loadingStatus: LoadingStatusReducerState;
  loginUser: UserState;
  isLoggedIn: boolean;
  storeSelector: StoreSelectorState;
  header: ContentHeaderProps;
  fetchDashboardSummaryCount: (userId: string, targetStores: string[]) => void;
  updateRefresh: (userId: string, targetStores: string[]) => void;
  setToggleModal: () => void;
  setToggleStore: (store: StoreAndAgencyInfo) => void;
}

interface LatestSummaryState {
  loginStores: string[];
  isOpenDrawer: boolean;
  isCollapsedStore: boolean;
  isInitialization: boolean;
  activeTooltipId: string;
}

// リフレッシュボタンのGAイベント関数
const refreshSpotEvent = REFRESH_SPOT_EVENT_MAPPING['AGENCY']['dashboard'];

class LatestSummary extends Component<LatestSummaryProps, LatestSummaryState> {
  constructor(props: LatestSummaryProps) {
    super(props);
    this.state = {
      loginStores: Object.values(this.props.storeSelector.stores ?? {})
        .filter((store) => store.selectedForFilter)
        .map((store) => store.agencyCd),
      isOpenDrawer: false,
      isCollapsedStore: false,
      isInitialization: true,
      activeTooltipId: '',
    };
    this.setActiveTooltipId = this.setActiveTooltipId.bind(this);
  }

  componentDidMount() {
    // customCountListの箱取得API
    const userId = this.props.loginUser.crewCd;
    const targetStores = Object.values(this.props.storeSelector.stores ?? {})
      .filter((store) => store.selectedForFilter)
      .map((store) => store.agencyCd);

    if (this.props.isLoggedIn) {
      this.props.fetchDashboardSummaryCount(userId, targetStores);
    }

    // Refresh buttonの更新
    this.props.updateRefresh(userId, targetStores);
    Object.values(DASHBOARD_HEADER_SPOT_EVENT_MAPPING['AGENCY']).forEach(({ id, spotEvent }) => {
      document.querySelector(`#${id}`)?.setAttribute('onclick', spotEvent);
    });
  }

  componentWillUpdate(nextProps: LatestSummaryProps) {
    const userId = nextProps.loginUser.crewCd;
    const targetStores = Object.values(nextProps.storeSelector.stores ?? {})
      .filter((store) => store.selectedForFilter)
      .map((store) => store.agencyCd);

    // Login既にしてて、店舗選択で店舗が切り替わったら
    if (
      targetStores.length !== this.state.loginStores.length ||
      !targetStores.every((store, index) => store === this.state.loginStores[index]) ||
      (this.props.isLoggedIn && this.state.isInitialization)
    ) {
      this.setState({ isInitialization: false });
      // Refresh buttonの更新
      this.setState({ loginStores: targetStores });
      this.props.updateRefresh(userId, targetStores);
      if (this.props.isLoggedIn) {
        this.props.fetchDashboardSummaryCount(userId, targetStores);
      }
    }
  }

  /**
   * アクティブの注釈IDを設定
   * @returns void
   */
  setActiveTooltipId(id: string) {
    this.setState({ activeTooltipId: id });
  }

  // 絞り込みドロワー
  renderDrawer() {
    return (
      <Drawer
        className='filter-drawer'
        isOpen={this.state.isOpenDrawer}
        isOverayTransparent
        onClose={() => this.setState({ isOpenDrawer: false })}
        position='right'>
        <div className='filter-drawer__inner' data-testid='filterSettingDrawer'>
          <div className='filter-drawer__header'>
            <h3 className='headline-4 u-float-left'>絞り込み条件</h3>
            <IconButton
              id={DASHBOARD_HEADER_SPOT_EVENT_MAPPING['AGENCY']['close'].id}
              className='u-float-right u-mn8'
              icon='close'
              onClick={() => this.setState({ isOpenDrawer: false })}
              data-testid='drawer-close-icon-button'
              data-testid-e2e='drawer-close-icon-button'
            />
          </div>
          <div className='filter-drawer__content u-p0'>
            <div className='u-pv24 u-ph16'>
              <>
                <hr className='uc-divider u-mb8 u-mhn16' />
                <div className='uc-form-field u-mt24'>
                  <div className='uc-form-field__label　u-float-left u-mb16'>
                    <span
                      className='filter-drawer__collapse'
                      onClick={() => this.setState({ isCollapsedStore: !this.state.isCollapsedStore })}>
                      <Icon className={classNames('filter-drawer__arrow-icon', this.state.isCollapsedStore && 'is-rotate')}>
                        keyboard_arrow_up
                      </Icon>
                      <span className='u-text-middle u-text-bold'>表示する店舗</span>
                    </span>
                    {/* クリックして店舗選択モーダルを表示する */}
                    <Button
                      id={DASHBOARD_HEADER_SPOT_EVENT_MAPPING['AGENCY']['selectStoreFilter'].id}
                      className='u-w5s u-float-right'
                      type='transparent'
                      height='s'
                      leftIcon='store'
                      label='店舗/店舗フィルタを選択'
                      data-testid-e2e='filterSettingDrawer-addStore'
                      onClick={() => this.props.setToggleModal()}
                    />
                  </div>
                  <Collapse in={!this.state.isCollapsedStore}>
                    <div className='uc-form-field__control'>
                      {this.props.storeSelector.sortedModalSelectedStores
                        .map((agencyCd) => this.props.storeSelector?.stores?.[agencyCd] || this.props.storeSelector?.agencies?.[agencyCd])
                        .map(
                          (store) =>
                            store && (
                              <Badge
                                className='agency-store-tag u-mr8 u-mb8'
                                activeClassName='agency-store-tag--active'
                                isActive={store?.selectedForFilter ?? false}
                                onClick={() => {
                                  this.props.setToggleStore(store);
                                }}>
                                {getAgencyStoreShortName(store.shortName, store.agencyCd, String(store.companyCfc))}
                              </Badge>
                            )
                        )}
                      {['dev'].includes(process.env.REACT_APP_ENV ?? '') && (
                        <>
                          {/* スタイリング見せるため */}
                          {['ソフトバンク舞浜', 'ソフトバンク桜木町', 'ソフトバンク赤坂'].map((item, index) => (
                            <Badge className='agency-store-tag u-mr8 u-mb8' activeClassName='agency-store-tag--active' isActive={index > 3}>
                              {item}
                            </Badge>
                          ))}
                          <p className='u-text-m u-text-disabled'>設定されていません</p>;
                        </>
                      )}
                    </div>
                  </Collapse>
                  <StoreSelectModal />
                </div>
              </>
            </div>
          </div>
          <div className='filter-drawer__footer'>
            <Button
              id={DASHBOARD_HEADER_SPOT_EVENT_MAPPING['AGENCY']['cancel'].id}
              onClick={() => this.setState({ isOpenDrawer: false })}
              className={`u-mr16`}
              type='transparent'
              label='キャンセル'
              data-testid-e2e='filterSettingDrawer-close'
              data-testid='filterSettingDrawer-close'
            />
          </div>
        </div>
      </Drawer>
    );
  }

  render() {
    return (
      <Layout isLoggedIn={this.props.loginUser.isLoggedIn}>
        <div className='layout-main__right-scroll-area container'>
          <ContentHeader
            screenName={this.props.header.screenName}
            screenId={this.props.header.screenId}
            gaSpotEvent={refreshSpotEvent}
            statusType={this.props.header.statusType}
            loadingStatus={this.props.header.loadingStatus}
            className='u-mb8'
            data-testid='contentHeader'>
            <SearchConditionInput
              id={DASHBOARD_HEADER_SPOT_EVENT_MAPPING['AGENCY']['searchDisplay'].id}
              toggleDrower={() => {
                this.setState({ isOpenDrawer: !this.state.isOpenDrawer });
              }}
              data-testid='searchConditionInput'
            />
            {this.renderDrawer()}
          </ContentHeader>
          <NegotiationCountListContainer
            loadingStatus={this.props.header.loadingStatus}
            data-testid='negotiationCountListContainer'
            gaSpotEvent={LASTEST_SUMMARY_SPOT_EVENT_MAPPING['AGENCY']}
            activeTooltipId={this.state.activeTooltipId}
            setActiveTooltipId={this.setActiveTooltipId}
          />

          <CustomCountListContainer
            gaSpotEvent={DASHBOARD_CUSTOM_COUNT_SPOT_EVENT_MAPPING['AGENCY']}
            data-testid='customCountListContainer'
          />

          {/* DashboardBIArea */}
        </div>
      </Layout>
    );
  }
}

export default LatestSummary;
